import React, { useEffect } from 'react';
import { FlagProvider, useUnleashContext } from '@unleash/proxy-client-react';
import { useSelector } from 'react-redux';
import { selectPrivyToken } from '../../redux/slices/auth.js';
import { useGetCurrentUserProfileQuery } from '../../redux/api/authorized/auth.js';
import {
  selectValidationResult,
  selectSessionId,
} from '../../redux/slices/sessionValidation.js';

const defaultConfig = {
  url: 'https://us.app.unleash-hosted.com/usdd0004/api/frontend/',
  clientKey: import.meta.env.VITE_UNLEASH_TOKEN,
  appName: 'unleash-onboarding-react',
  context: {
    properties: {
      userId: 'anonymous',
    },
  },
};

const UnleashContext = ({ children }) => {
  const privyToken = useSelector(selectPrivyToken);
  const { data, isLoading } = useGetCurrentUserProfileQuery(undefined, {
    skip: !privyToken,
  });

  const validationResult = useSelector(selectValidationResult);
  const sessionId = useSelector(selectSessionId);

  const updateContext = useUnleashContext();

  // Consolidate all context updates into one effect
  useEffect(() => {
    async function updateUserContext() {
      if (isLoading) return;

      // Use user ID if available, otherwise use session ID
      const userId = data?.id
        ? data.id.toString()
        : sessionId || 'anonymous';

      // Build the complete context update with all fields
      const contextUpdate = {
        userId,
        countryCode: validationResult?.countryCode || '',
        sessionValidationAllowed: String(validationResult?.allowed ?? false),
      };

      await updateContext(contextUpdate);
    }
    updateUserContext();
  }, [data?.id, sessionId, validationResult, isLoading, updateContext]);

  return children;
};

const UnleashProvider = ({ children }) => {
  return (
    <FlagProvider config={defaultConfig}>
      <UnleashContext>{children}</UnleashContext>
    </FlagProvider>
  );
};

export default UnleashProvider;
